// state
const state = {
  parkingOnGis: null,
  parkingOffGis: null,
  parkingPanelGis: null,
  bikeGis: null,
  busStopGis: null,
  busLineGis: null,
  busGis: null,
  busRealTimeGis: null,
  layers: {
    sensorZones: ['sensorZones', 'UPDATE_PARKING_ON_GIS'],
    parking: ['parking', 'UPDATE_PARKING_OFF_GIS'],
    panelParking: ['panelParking', 'UPDATE_PARKING_PANEL_GIS'],
    bike: ['bike', 'UPDATE_BIKE_GIS'],
    busStop: ['busStop', 'UPDATE_BUS_STOP_GIS'],
    busLine: ['busLine', 'UPDATE_BUS_LINE_GIS'],
    bus: ['busRealTime', 'UPDATE_BUS_GIS'],
    busRealTime: ['busRealTime', 'UPDATE_BUS_REAL_TIME_GIS']
  }
}

// getters
const getters = {
  // PARKING
  getParkingOnGisData (state) {
    return state.parkingOnGis
  },
  getParkingOffGisData (state) {
    return state.parkingOffGis
  },
  getParkingPanelGisData (state) {
    return state.parkingPanelGis
  },
  getBikeGisData (state) {
    return state.bikeGis
  },
  getBusStopGisData (state) {
    return state.busStopGis
  },
  getBusLineGisData (state) {
    return state.busLineGis
  },
  getBusGisData (state) {
    return state.busGis
  },
  getBusRealTimeGisData (state) {
    return state.busRealTimeGis
  }
}

// actions
const actions = {
  // Update Data Gis
  getMobilityGisData ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      state.stationsAirGis = null
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentGis',
        data: null,
        params: {
          type: data[0],
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: data[1]
      }
      store.dispatch('callService', dataService)
    }
  },
  getAllParkingGisData ({ commit, state }) {
    const store = this
    // GIS
    // POLIGONOS APARCAMIENTOS
    store.dispatch('getMobilityGisData', state.layers.sensorZones)
    // PUNTOS APARCAMIENTOS
    store.dispatch('getMobilityGisData', state.layers.parking)
    // PUNTOS PANELES
    store.dispatch('getMobilityGisData', state.layers.panelParking)
    // PUNTOS BICIS
    store.dispatch('getMobilityGisData', state.layers.bike)
    // BUS STOP
    store.dispatch('getMobilityGisData', state.layers.busStop)
    // BUS LINE
    store.dispatch('getMobilityGisData', state.layers.busLine)
    // BUS
    store.dispatch('getMobilityGisData', state.layers.bus)
  },
  getBusRealTimeData ({ commit, state }) {
    const store = this
    // BUS REAL TIME UPDATE INTERVAL
    store.dispatch('getMobilityGisData', state.layers.busRealTime)
  }
}

// mutations
const mutations = {
  UPDATE_PARKING_ON_GIS (state, data) {
    state.parkingOnGis = data
  },
  UPDATE_PARKING_OFF_GIS (state, data) {
    state.parkingOffGis = data
  },
  UPDATE_PARKING_PANEL_GIS (state, data) {
    state.parkingPanelGis = data
  },
  UPDATE_BIKE_GIS (state, data) {
    state.bikeGis = data
  },
  UPDATE_BUS_STOP_GIS (state, data) {
    state.busStopGis = data
  },
  UPDATE_BUS_LINE_GIS (state, data) {
    state.busLineGis = data
  },
  UPDATE_BUS_GIS (state, data) {
    state.busGis = data
  },
  UPDATE_BUS_REAL_TIME_GIS (state, data) {
    state.busRealTimeGis = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardMobility.js